export default "__VITE_ASSET__jP219sRL__"